var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Trainer--Streamline-Atlas.svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.75 -0.75 20 20",
    height: 25,
    width: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Trainer Streamline Icon: https://streamlinehq.com")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.777708333333334 1.15625h2.952291666666667a2.2122916666666668 2.2122916666666668 0 0 1 2.2122916666666668 2.2122916666666668v3.6845833333333338A3.6845833333333338 3.6845833333333338 0 0 1 9.25 10.737708333333334a3.6845833333333338 3.6845833333333338 0 0 1 -3.6845833333333338 -3.6845833333333338V3.3685416666666668a2.2122916666666668 2.2122916666666668 0 0 1 2.2122916666666668 -2.2122916666666668Z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.565416666666667 4.1085416666666665h7.376875000000001a2.2122916666666668 2.2122916666666668 0 0 1 -2.22 2.2122916666666668h-2.9445833333333336a2.2122916666666668 2.2122916666666668 0 0 1 -2.2122916666666668 -2.2122916666666668Z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.613125 18.114583333333336v-0.7708333333333334A6.644583333333333 6.644583333333333 0 0 1 9.25 10.737708333333334a6.644583333333333 6.644583333333333 0 0 1 6.636875 6.636875v0.7708333333333334",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51 15.902291666666667a0.74 0.74 0 1 0 1.48 0 0.74 0.74 0 1 0 -1.48 0",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.990000000000002 18.114583333333336 0 -2.2122916666666668",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.565416666666667 10.745416666666667 9.25 15.162291666666668l3.6845833333333338 -4.416875",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/Coach.4b197dd8480d4d52e70bf9935861d355.svg";
export { ForwardRef as ReactComponent };